module.exports = __webpack_public_path__ + "img/flower-crown.0d1b78a6.png";